import { useWSMutation } from "../../helpers";
import {
  IUpdateBackgroundCheckUpdateRequest,
  updateBackgroundChecksSettings
} from "../../../services/backgroundChecks/updateBackgroundChecksSettings";
import { QUERY_BACKGROUND_CHECKS_SETTINGS } from "../queries/useQueryBackgroundChecksSettings";

export const useMutationUpdateBackgroundCheckSettings = () =>
  // TODO: implement update background check settings
  useWSMutation(
    (request: IUpdateBackgroundCheckUpdateRequest & { dataSourceId: string }) =>
      updateBackgroundChecksSettings(request.dataSourceId, request),
    {
      dependencies(response, request) {
        return [
          QUERY_BACKGROUND_CHECKS_SETTINGS,
          response.backgroundCheckPackageId
        ];
      }
    }
  );
